import React from 'react';
import MainLayout from '../../../layouts/dashboard/MainLayout';
import { StyleSheet, View } from 'react-native';
import { Title } from '../../../components/texts';
import ModuleContentView from '../../../layouts/dashboard/ModuleContentView';
import { Colors } from '../../../styles/theme';
import { InputText } from '../../../components/inputs/InputText';
import { Button } from '../../../components/buttons';
import { useUserContext } from '../../../providers/UserProvider';
import { useSnackBarContext } from '../../../providers/SnackBarProvider';
import { useNavigation } from '@react-navigation/native';
import {ROUTES} from "../../../router/Routes";

const UpdateMyCodeScreen = () => {
  const userContext = useUserContext();
  const {navigate} = useNavigation();
  const { displaySnackBar } = useSnackBarContext();
  const [pin, setPin] = React.useState<string>(userContext.userState?.profile?.user?.pinCode);
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleSubmitPin = async () => {
    setLoading(true);
    const response = await userContext.updateMyCaregiverProfile({ id: userContext.userState.profile.id, pinCode: pin });
    if (response) {
      displaySnackBar('Modification enregistrée !', 'SUCCESS');
      navigate(ROUTES.HOME_SCREEN.name);
    } else {
      displaySnackBar('Une erreur est survenue', 'ERROR');
    }
    setLoading(false);
  };

  const handleSetPin = (value: string) => {
    if (value.toString().length > 4) return;
    setPin(value.replace(/\D/g, ''));
  };

  return (
    <MainLayout backButton serviceCard>
      <ModuleContentView>
        <View>
          <Title h2>Informations</Title>
          <View style={styles.detailsContainer}>
            <Title h3>Changer de code pin</Title>
            <InputText label={'Code pin'} value={pin} onChangeText={(value) => handleSetPin(value)} numeric />
            <Button label={'Valider'} success onPress={handleSubmitPin} loading={loading} />
          </View>
        </View>
      </ModuleContentView>
    </MainLayout>
  );
};

export default UpdateMyCodeScreen;

const styles = StyleSheet.create({
  detailsContainer: {
    backgroundColor: Colors.WHITE,
    borderRadius: 30,
    shadowColor: '#b1b1b1',
    shadowOffset: {
      width: 9,
      height: 9,
    },
    padding: 20,
    marginVertical: 10,
  },
});
